import { ElasticSearchHit } from '@infa-hawk/services/src/services/ccgf-searchv2/ElasticService.types';
import { browseResultsApi, browseServiceApi, IBrowseConnection } from '@infa-service/cdgc-connection';
import { ITask } from '@infa-service/mdp-orchestration-api';

import { Steps, StepStatus } from '../../../component/core/step-progress/StepProgress';
import { TreeItemType } from '../../../component/core/tree/Tree';

export enum STATUS {
	LOADING,
	JOB_RUNNING,
	SUCCESS,
	FAILURE,
	SYNC_EXPLORER,
}
export interface ITaskDetails extends ITask {
	childrens?: Steps[];
	message?: string;
	state?: StepStatus;
}
type FilterValue = {
	name: string;
	value: string;
};
/**
 *
 * @param {FilterValue} filterValues
 * @description
 * @returns
 */
export const extractAndFormatFilterValue = (filterValues: FilterValue[]): string | null => {
	const filterValueObj = filterValues.find((fv) => fv.name === 'Filter Value');

	if (!filterValueObj) {
		return null;
	}
	const filterValue = filterValueObj.value;
	/*eslint no-useless-escape: "warn"*/
	const formattedValue = filterValue.replace(/\"/g, '');
	return formattedValue;
};

export const extractFilterType = (filterValues: FilterValue[]): string | null => {
	const filterValueObj = filterValues.find((fv) => fv.name === 'Filter Type');
	if (!filterValueObj) {
		return null;
	}
	return filterValueObj.value;
};

/**
 * Extracts warehouse, database, and table names from a location string.
 * @param {string} location - The location string in the format '/path/to/warehouseName/dbName/tableName'.
 * @returns {{warehouseName: string, dbName: string, tableName: string}} An object containing the extracted names.
 */
export const getTableLocation = (location: string) => {
	const [, , , warehouseName, dbName, tableName] = location.split('/');
	return { warehouseName, dbName, tableName };
};

/**
 * Sorts the tree items alphabetically based on their 'label' property.
 * This function works recursively on nested children.
 * @param {TreeItemType[]} treeItems - An array of TreeItemType objects to be sorted.
 * @returns {TreeItemType[]} A new array of TreeItemType objects, sorted alphabetically.
 */
export const sortTableAlphabatically = (treeItems: TreeItemType[]): TreeItemType[] =>
	treeItems
		.map((item) => {
			if (item.childrens && item.childrens.length > 0) {
				return {
					...item,
					childrens: sortTableAlphabatically(item.childrens),
				};
			}
			return item;
		})
		.sort((a, b) => a.label.localeCompare(b.label));

export const formTableLocationFromJobFilters = (csId: string, heirarchy: string[]) => {
	const [warehouseName, dbName, tableName] = heirarchy;
	return `${csId}://${csId}/${warehouseName}/${dbName}/${tableName}`;
};

export const generateHierarchicalValue = (param: { csId: string; parentValue?: string | null; nodeLabel: string }): string => {
	const { csId, parentValue, nodeLabel } = param;
	return parentValue ? `${parentValue}/${nodeLabel}` : `${csId}://${nodeLabel}`;
};
//TODO this a temperary solution for forming filterValue from externalId not reliable
export const getFilterValueFromExternalId = (csId: string, csName: string, externalId: string) => {
	const prefix = `${csId}://`;
	if (externalId.startsWith(prefix)) {
		const parts = externalId.split('/');
		return [csName, ...parts.slice(2)].join('.');
	}
	return null;
};

export const getParentName = (hit: ElasticSearchHit): string => hit['__meta.parentLocation'].split('/').pop();
export class BrowseServiceApiClone {
	async getChildren({ req, connectionId }: { req: IBrowseConnection; connectionId: string }) {
		const { ticketId, minResponseTime } = await browseServiceApi.browseConnection({
			connectionId,
			browseConnection: { ...req },
		});

		if (ticketId && minResponseTime) {
			let ready = false;

			while (!ready) {
				ready = await browseResultsApi.ticketResultReady({ ticketId });
				if (!ready) {
					await new Promise((resolve) => setTimeout(resolve, 2000));
				}
			}

			return browseResultsApi.fetchBrowseResults({ ticketId });
		} else {
			return Promise.reject('failed to fetch browse content');
		}
	}
}
